import React, { useState } from 'react';
import { WHY_CHRIST_FEATURES } from '../data/coursesData';
import { MonitorPlay, Video, UserCheck, CheckCircle2, Sparkles, Laptop, Layers } from 'lucide-react';

const iconMap = {
  MonitorPlay: <MonitorPlay size={24} color="#D4AF37" />,
  Video: <Video size={24} color="#D4AF37" />,
  UserCheck: <UserCheck size={24} color="#D4AF37" />,
  CheckCircle2: <CheckCircle2 size={24} color="#D4AF37" />
};

export default function WhyChrist() {
  const [activeFeatureId, setActiveFeatureId] = useState('lms');

  const activeFeature = WHY_CHRIST_FEATURES.find(f => f.id === activeFeatureId) || WHY_CHRIST_FEATURES[0];

  return (
    <section id="why-christ" style={{ padding: '5rem 0', backgroundColor: '#FFFFFF' }}>
      <div className="container">

        {/* Header */}
        <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 3.5rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: '#FEF3C7',
            color: '#92400E',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            <Sparkles size={14} color="#D4AF37" /> Next-Gen Online Learning Experience
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#0F2537', letterSpacing: '-0.02em' }}>
            Why Choose CHRIST (Deemed to be University) Online?
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#64748B', marginTop: '0.5rem', lineHeight: 1.6 }}>
            Experience an unmatched blend of academic rigor, flexible schedule, and cutting-edge educational technology built for working professionals.
          </p>
        </div>

        {/* Interactive Showcase Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2.5rem',
          alignItems: 'center'
        }}>
          
          {/* Navigation List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {WHY_CHRIST_FEATURES.map((feature) => (
              <div
                key={feature.id}
                onClick={() => setActiveFeatureId(feature.id)}
                style={{
                  padding: '1.35rem',
                  borderRadius: '14px',
                  border: activeFeatureId === feature.id ? '2px solid #0F2537' : '1px solid #E2E8F0',
                  backgroundColor: activeFeatureId === feature.id ? '#0F2537' : '#F8FAFC',
                  color: activeFeatureId === feature.id ? '#FFFFFF' : '#0F172A',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: activeFeatureId === feature.id ? '0 10px 25px rgba(15, 37, 55, 0.15)' : 'none'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    backgroundColor: activeFeatureId === feature.id ? 'rgba(212, 175, 55, 0.2)' : '#FFFFFF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #CBD5E1'
                  }}>
                    {iconMap[feature.icon]}
                  </div>
                  <h4 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>
                    {feature.title}
                  </h4>
                </div>
                <p style={{
                  fontSize: '0.88rem',
                  color: activeFeatureId === feature.id ? '#CBD5E1' : '#64748B',
                  lineHeight: 1.5,
                  margin: 0,
                  paddingLeft: '3.6rem'
                }}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* Feature Preview Card */}
          <div style={{
            backgroundColor: '#07131E',
            borderRadius: '20px',
            padding: '2.5rem',
            color: '#FFFFFF',
            border: '2px solid rgba(212, 175, 55, 0.3)',
            boxShadow: '0 25px 50px -12px rgba(15, 37, 55, 0.35)',
            position: 'relative'
          }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              backgroundColor: 'rgba(212, 175, 55, 0.15)',
              color: '#FEF08A',
              fontSize: '0.78rem',
              fontWeight: 700,
              padding: '0.3rem 0.75rem',
              borderRadius: '9999px',
              marginBottom: '1rem'
            }}>
              <Laptop size={14} color="#D4AF37" /> Feature Showcase
            </div>

            <h3 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#FFFFFF', marginBottom: '0.75rem' }}>
              {activeFeature.title}
            </h3>

            <p style={{ fontSize: '0.95rem', color: '#CBD5E1', lineHeight: 1.6, marginBottom: '1.75rem' }}>
              {activeFeature.description}
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem', marginBottom: '2rem' }}>
              {activeFeature.highlights.map((h, i) => (
                <div key={i} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  padding: '0.85rem 1rem',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  fontSize: '0.9rem',
                  color: '#F1F5F9',
                  fontWeight: 600
                }}>
                  <CheckCircle2 size={18} color="#10B981" />
                  <span>{h}</span>
                </div>
              ))}
            </div>

            <div style={{
              backgroundColor: 'rgba(212, 175, 55, 0.08)',
              borderRadius: '12px',
              padding: '1rem',
              border: '1px dashed rgba(212, 175, 55, 0.3)',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              fontSize: '0.82rem',
              color: '#FEF08A'
            }}>
              <Layers size={20} color="#D4AF37" />
              <span>
                All Christ Online students receive complimentary access to 10,000+ e-books & international research journals.
              </span>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
}
